// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".overview-openings{display:flex;flex-direction:column;row-gap:40px}.overview-openings .section-header{color:#31363a;font-size:24px;font-style:normal;font-weight:700;letter-spacing:-.48px;line-height:44px;margin-bottom:24px}.overview-openings .by-attribute-tiles{-moz-column-gap:24px;column-gap:24px;display:flex;flex-wrap:no-wrap;overflow-x:auto;scrollbar-color:#5341c6 #fff;scrollbar-width:thin}", ""]);
// Exports
module.exports = exports;
